<template>
  <div class="register">
    <ul class="language">
        <li>
            <img src="@/assets/image/language-icon.png" alt="">
            <span class="language-content">{{$t('language')}}</span>
            <ul>
                <li @click="changeLang('zh')">中文简体</li>
                <li @click="changeLang('en')">English</li>
            </ul>
        </li>
        <li style="padding:0">
            |
        </li>
        <li>
            <span>{{$t('backHome')}}</span>
        </li>
    </ul>
    <div class="login-div">
        <img src="@/assets/image/loginLogo.png" alt="">
        <ul class="reg-tab">
            <li :class="isRealorDemo?'active':''" @click="tabChange">{{$t('regOpenReal')}}</li>
            <li :class="!isRealorDemo?'active':''" @click="tabChange">{{$t('regOpenDemo')}}</li>
        </ul>
        <Form v-show="isRealorDemo" :model="realModel" class="loginForm" ref="realForm" :rules="realRules">
            <FormItem prop="firstName">
                <Input v-model="realModel.firstName" :placeholder="$t('firstName')"></Input>
            </FormItem>
            <FormItem prop="lastName">
                <Input v-model="realModel.lastName" :placeholder="$t('lastName')"></Input>
            </FormItem>
            <FormItem  prop="email">
                <Input v-model="realModel.email" :placeholder="$t('email')" ></Input>
            </FormItem>
            <FormItem prop="verifyCode">
                <Input style="width:50%" v-model="realModel.verifyCode" :placeholder="$t('asd')"></Input>
                <Button class="sendBtn" :loading="!send" :disabled="countParams.disabled" @click="sendVerifyCode">{{countParams.txt}}</Button>
            </FormItem>
            <FormItem prop="countryCode" class="regSelect">
                <Select v-model="realModel.countryCode" :placeholder="$t('select')" :filterable="filterable">
                    <Option v-for="(item,index) in countryList" :key="index" :value="item.value">{{item.label}}</Option>
                </Select>
                <!-- <Input v-model="realModel.countryCode" :placeholder="$t('loginPassword')"></Input> -->
            </FormItem>
            <FormItem prop="phone">
                <Input v-model="realModel.phone" :placeholder="$t('phone')"></Input>
            </FormItem>
            <FormItem prop="password">
                <Input type="password"  v-model="realModel.password" :placeholder="$t('password')"></Input>
            </FormItem>
            <FormItem prop="confirmPassword">
                <Input type="password"  v-model="realModel.confirmPassword" :placeholder="$t('confirmPassword')"></Input>
            </FormItem>
            <FormItem>
                <Button  class="loginBtn" @click="register">{{$t('reg')}}</Button>
            </FormItem>
            <FormItem>
                 <Button  class="regBtn" @click="toLogin">{{$t('loginAccount')}}</Button>
            </FormItem>
           
        </Form>
        <Form v-show="!isRealorDemo" :model="demoModel" class="loginForm" ref="demoForm" :rules="demoRules">
            <FormItem prop="firstName">
                <Input v-model="demoModel.firstName" :placeholder="$t('firstName')"></Input>
            </FormItem>
            <FormItem prop="lastName">
                <Input v-model="demoModel.lastName" :placeholder="$t('lastName')"></Input>
            </FormItem>
            <FormItem prop="country" class="regSelect">
                <Select v-model="demoModel.country" :placeholder="$t('select')" :filterable="filterable">
                    <Option v-for="(item,index) in countryList" :key="index" :value="item.value">{{item.label}}</Option>
                </Select>
                <!-- <Input v-model="realModel.countryCode" :placeholder="$t('loginPassword')"></Input> -->
            </FormItem>
            <FormItem prop="phone">
                <Input v-model="demoModel.phone" :placeholder="$t('phone')"></Input>
            </FormItem>
            <FormItem  prop="email">
                <Input v-model="demoModel.email" :placeholder="$t('email')"></Input>
            </FormItem>
            <FormItem>
                <Button style="margin-top:2px" class="regBtn" @click="openDemo">{{$t('reg')}}</Button>
            </FormItem>
            <FormItem>
                <Button  class="loginBtn" @click="toLogin">{{$t('loginAccount')}}</Button>
            </FormItem>
            <FormItem>
                 <Button  class="loginBtn" @click="tabChange">{{$t('regOpenReal')}}</Button>
            </FormItem>
           
        </Form>
    </div>
    <div class="login-txt">
        <p class="footer_title">{{$t('footerTitle1')}}</p>
        <p class="footer_content">
            {{$t('topTips1')}}
        <span>{{$t('topTips2')}}</span>
        {{$t('topTips3')}}</p>
        </p>
        <p class="footer_title">{{$t('footerTitle2')}}</p>
        <p class="footer_content">{{$t('footerTips2')}}</p>
        <p class="footer_title">{{$t('footerTitle3')}}</p>
        <p class="footer_content">{{$t('footerTips3')}}</p>
        <p class="footer_content">{{$t('footerTips4')}}</p>
    </div>
    <loading :isSpinShow="loading"></loading>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import { setup } from '@/langs'
import Loading from '@/components/Loading.vue';
import { cloneObjectFn } from '../plugins/common.js'
import _MIXINS_ from '@/mixins'


export default {
    name: 'Login',
    components: {
        Loading
    },
    data() {
        const validatePass = (rule, value, callback) => {
            if (value.trim() === '') {
                callback(new Error(this.$t('loginTips2')));
            } else{
                var passCheck = /^[a-zA-Z]\w{5,17}$/g
                if (!passCheck.test(value)){
                    callback(new Error(this.$t('passwordcheck')))
                }else{
                    callback();
                }
                if (this.realModel.passwdCheck !== '') {
                    // 对第二个密码框单独验证
                    this.$refs.realForm.validateField('confirmPassword');
                }
            }
        };
        const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('confirmPasswordCheck')));
            } else if (value !== this.realModel.password) {
                callback(new Error(this.$t('twoPasswordCheck')));
            } else {
                callback();
            }
        };
        const emailCheck = (rule, value, callback) => {
            var emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/g
            if (value.trim() === '') {
                callback(new Error(this.$t('loginTips1')));
            } else if(!emailReg.test(value)){
                callback(new Error(this.$t('emailcheck')))
                
            }else{
                callback();
            }
        };
        return {
            realModel:{
                firstName: "",
                lastName: "",
                phone: "",
                email: "",
                verifyCode:'',
                countryCode:'',
                password: "",
                confirmPassword: "",
                lang: localStorage.getItem('localeLanguage'),
                userType: 0
            },
            demoModel:{
                firstName: "",
                lastName: "",
                phone: "",
                email: "",
                country:'',
            },
            checked:false,
            isRealorDemo:true,
            countryList:[],
            realRules: {
                firstName: [
                    { required: true, message: this.$t('firstNameCheck') , trigger: 'blur' },
                ],
                lastName: [
                    { required: true, message: this.$t('lastNameCheck') , trigger: 'blur' },
                ],
                countryCode: [
                    { required: true, message: this.$t('countryCheck'),trigger: 'change'  },
                ],
                phone: [
                    { required: true, message:this.$t('phoneCheck') , trigger: 'blur' },
                ],
                email: [
                    { validator: emailCheck , trigger: 'change' },
                    // { required: true, message:this.$t('loginTips1') , trigger: 'blur' },
                    // { pattern: '/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/g', message: this.$t('emailcheck'), trigger: 'change' }
                ],
                verifyCode: [
                    { required: true, message:this.$t('asdPl') , trigger: 'blur' },
                ],
                password: [
                    { validator: validatePass , trigger: 'change' },
                ],
                confirmPassword: [
                    { validator: validatePassCheck , trigger: 'change' },
                    // { type: 'string', min: 6, message: '', trigger: 'blur' }
                ]
            },
            demoRules: {
                firstName: [
                    { required: true, message: this.$t('firstNameCheck') , trigger: 'blur' },
                ],
                lastName: [
                    { required: true, message: this.$t('lastNameCheck') , trigger: 'blur' },
                ],
                country: [
                    { required: true, message: this.$t('countryCheck'),trigger: 'change' },
                ],
                phone: [
                    { required: true, message:this.$t('phoneCheck') , trigger: 'blur' },
                ],
                email: [
                    { validator: emailCheck , trigger: 'change' },
                    // { required: true, message:this.$t('loginTips1') , trigger: 'blur' },
                    // { pattern: '/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/g', message: this.$t('emailcheck'), trigger: 'change' }
                ],
            },
            loading:false,
            filterable:true,
            send:true,
			click:true
        }
    },
    mixins: [_MIXINS_.countdown],
    computed: {
        ...mapState(['lang'])
    },
    created(){
        this.getCountry()
    },
    methods: {
        changeLang(value){
            setup(value)
            location.reload()
        },
        tabChange(){
            this.$refs.realForm.resetFields()
            this.$refs.demoForm.resetFields()
            this.isRealorDemo = !this.isRealorDemo
        },
        toLogin(){
            this.$router.push({ path:'/login'})
        },
        getCountry(){
            this.countryList = []
            this.$axios.get('/api/CreateRealAccount/Index')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    res.data.obj.forEach(e => {
                        let data = {
                            value:e.id.toString()
                        }
                        if(this.lang == 'zh'){
                            data.label = '+'+e.areaCode.substring(2)+' '+e.nameCN
                        }else{
                            data.label = '+'+e.areaCode.substring(2)+' '+e.name
                        }
                        this.countryList.push(data)
                    });
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => {
                this.$Message.error(err.data.msg)
            })
        },
        sendVerifyCode(){
            this.$refs.realForm.validateField('email',(valid) => {
                if(!valid){
					if(this.send){
						this.send = false
					}else{
						return false
					}
                    this.$axios.get('/api/Public/SendEamilVerifyCode',{
						params:{
							email:this.realModel.email,
                            type:0,
                            key:'register'
						}
					})
                    .then(async (res) => {
						this.send = true
                        if(res.data.status == 1){
							this.countdown()
                            this.$Message.success(res.data.msg)
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => {
						this.send = true
					})
                }
            })
        },
        register(){
            this.$refs.realForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    let params = JSON.parse(JSON.stringify(this.realModel))
                    params.password = this.$encrypt(params.password)
                    params.confirmPassword = this.$encrypt(params.confirmPassword)
                    this.$axios.post('/api/CreateRealAccount/Create', params)
                    .then(async (res) => {
                        // console.log(res)
                        if(res.data.status == 1){
                            // debugger
                            let _this = this
                            _this.$Modal.success({
                                title: _this.$t('registerTipsTitle'),
                                content: _this.$t('registerTips'),
                                okText:_this.$t('okText'),
                                onOk: () => {
                                    // _this.$router.push({ path:'/login'})
                                    const logindata = {
                                        email:this.realModel.email,
                                        password:this.$encrypt(this.realModel.confirmPassword)
                                    }
                                    _this.$axios.post('/api/Public/Login', logindata)
                                    .then(async (res) => {
                                        // console.log(res)
                                        if(res.data.status == 1){
                                            _this.$store.commit('setToken', res.data.obj.token)
                                            _this.$store.commit('setUserInfo', res.data.obj.userInfo)
                                            // debugger
                                            if(res.data.obj.userInfo.idCheckResultStatus == 1 || res.data.obj.userInfo.idCheckResultStatus == 0){
                                                _this.$router.push({ path:'/accountVerify'})
                                            }else if(res.data.obj.userInfo.idCheckResultStatus == 3){
                                                _this.$router.push({ path:'/verifyError'})
                                            }else{
                                                _this.$router.push({ path:'/myAccount'})
                                            }
                                        }else{
                                            _this.$Message.error(res.data.msg)
                                        }
                                    })
                                    .catch((err) => _this.$Message.error(err.data.msg))
                                }
                            });
                            // this.$Message.success(res.data.msg)
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => this.$Message.error(err.data.msg))
                    .finally(() => this.loading = false)
                } else {
                    // this.$Message.error('Fail!');
                }
            })
        },
        openDemo(){
            this.$refs.demoForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.$axios.post('/api/CreateDemoAccount/Create', this.demoModel)
                    .then(async (res) => {
                        // console.log(res)
                        if(res.data.status == 1){
                            let _this = this
                            _this.$Modal.success({
                                title: _this.$t('registerTipsTitle'),
                                content: _this.$t('demoTips'),
                                okText:_this.$t('okText'),
                                onOk: () => {
                                    _this.$router.push({ path:'/login'})
                                }
                            });
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => this.$Message.error(err.data.msg))
                    .finally(() => this.loading = false)
                } else {
                    // this.$Message.error('Fail!');
                }
            })
        }
    }
}
</script>
<style lang="less">
    .register{
        // height: 100%;
        position: relative;
        border: 1px solid transparent;
        .language{
            position: absolute;
            right: 2%;
            top: 20px;
            display: flex;
            flex-direction: row;
            li{
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 58px;
                line-height: 58px;
                padding: 0 40px 0 14px;
                color: #d12937;
                cursor: pointer;
                position: relative;
                img{
                    margin-right: 10px;
                }
                .language-content{
                    position: relative;
                }
                .language-content:after{
                    content: "";
                    position: absolute;
                    right: -18px;
                    top: 28px;
                    border-top: 5px solid #d12937;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;
                }
                ul{
                    position: absolute;
                    top: 50px;
                    left: 0;
                    background: #f0f0f0;
                    width: 100%;
                    display: none;
                    li{
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        color: #332c2b;
                        height: 50px;
                        line-height: 50px;
                    }
                    li:hover{
                        color: #d12937;
                    }
                }
            }
            li:hover ul{
                display: block;
            }
        }
        .login-div{
            width: 840px;
            height: 680px;
            // position: absolute;
            left:0; 
            right:0; 
            margin: auto;
            margin-top: 80px;
            img{
                margin: 50px auto;
                display: block;
            }
            .loginForm{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap: wrap;
                input,.ivu-select-selection{
                    min-height: 55px;
                    padding-left: 20px;
                    font-size: 16px;
                    border-color: #999999; 
                    border-radius: 10px;
                }
                .regSelect{
                    input{
                        padding-left: 0;
                    }
                }
                .ivu-select-selection{
                    div{
                         min-height: 55px;
                         span{
                            min-height: 55px;
                            line-height: 55px;
                            padding: 0;
                            font-size: 16px;
                         }
                    }
                }
                button{
                    width:100%;
                    margin-top:30px
                }
                .loginBtn{
                    border-radius: 25px;
                    line-height: 55px;
                    height: 55px;
                    background:#d60433;
                    color: #ffffff;
                    min-width: 200px;
                    font-size: 20px;
                    outline: none;
                    box-shadow:  0 0 25px rgba(0,0,0,.3)
                }
                .regBtn{
                    border-radius: 25px;
                    line-height: 55px;
                    height: 55px;
                    background:#ffffff;
                    color: #d12937;
                    min-width: 200px;
                    font-size: 20px;
                    outline: none;
                    border-color: #d02836;
                    box-shadow:  0 0 25px rgba(0,0,0,0.25);
                    min-width: 370px;
                    
                }
                .ivu-form-item-content{
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    .sendBtn{
                        border-radius: 25px;
                        line-height: 55px;
                        height: 55px;
                        background:#ffffff;
                        color: #d12937;
                        width: 45%;
                        font-size: 20px;
                        outline: none;
                        border-color: #d02836;
                        box-shadow:  0 0 25px rgba(0,0,0,.3);
                        margin-top: 0;
                    }
                }
            }
            .ivu-form-item{
                width: 48%;
            }
            .reg-tab{
                display: flex;
                flex-direction: row;
                margin-bottom: 30px;
                li{
                    width: 50%;
                    text-align: center;
                    padding-bottom: 18px;;
                    cursor: pointer;
                    font-size: 22px;
                    color: #332c2b;
                    border-bottom: 1px solid #e6e6e6;
                    position: relative;
                }
                li.active:after{
                    content: "";
                    position: absolute;
                    left: 50%;
                    bottom: 0px;
                    width: 76%;
                    height: 2px;
                    background-color: #d60433;
                    transform: translateX(-50%);
                    -webkit-transform: translateX(-50%);
                }
            }
        }
        .login-txt{
            width: 80%;
            // position: absolute;
            bottom: 10px;
            left: 0;
            right: 0;
            margin: auto;
            margin-bottom: 40px;
            .footer_title{
                font-size: 16px;
                color: #8b8b8c;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .footer_content{
                font-size: 14px;
                color: #8b8b8c;
                font-weight: 400;
                margin-bottom: 10px;
                span{
                    font-weight: 600;
                }
            }
        }
    }
</style>